import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useFirestore from "../../hooks/useFirestore";
import "../../styles/fonts.css";
import moment from "moment";

import "../../styles/index.css";
import AddNew from "../editprofs/AddNew";

const ClassDetails = (props) => {
  return (
    <li className='list-group-item col-11 mx-auto border col-md-5 col-lg-4 col-xl-3 my-1'>
      <Link to={`/acad/lec/${props.resource.id}`} className='nolinklook'>
        <div className=''>
          {props.resource.name && (
            <h5 className='fontcool text-center size09'>
              {props.id + 1} {props.resource.name}
            </h5>
          )}
          <p>
            <span className='blue-grey-text text-lighten-2'>
              {props.resource.date &&
                moment(props.resource.date.toDate()).format(
                  "MMMM Do YYYY, HH:MM"
                )}{" "}
            </span>
          </p>
          {props.resource.prof && (
            <h6 className='slantfont text-right mt-1'>{props.resource.prof}</h6>
          )}
        </div>
      </Link>
    </li>
  );
};

const CollectionProf = ({ prof }) => {
  const { docs } = useFirestore(prof);
  console.log(docs[0]);
  console.log(docs.length);
  return (
    <>
      <div className='card w-100 '>
        <div className='card-header'>
          <h4 className='card-title upperfont'>
            {prof} <i className='fas fa-caret-down'></i>
          </h4>
        </div>
        <div className='card-body'>
          <ul className='list-group row d-flex justify-content-around flex-row'>
            {docs &&
              docs.map((item, index) => (
                <ClassDetails
                  resource={item}
                  key={index}
                  id={index}
                  parent={prof.id}
                />
              ))}
          </ul>
          {docs[0] && (
            <AddNew
              id={`${
                prof &&
                prof.split(" ")[0] +
                  prof.split(" ")[1] +
                  "A2020" +
                  (docs.length + 1)
              }`}
              sub={prof}
              branch={docs[0].branch}
              course={docs[0].course}
              year={docs[0].year}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CollectionProf;
